import { render, staticRenderFns } from "./DrawingStatic.vue?vue&type=template&id=3ca24bdc&scoped=true&"
import script from "./DrawingStatic.vue?vue&type=script&lang=js&"
export * from "./DrawingStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca24bdc",
  null
  
)

export default component.exports